import { render, staticRenderFns } from "./SimpleNewsList.vue?vue&type=template&id=4cb969c5&scoped=true&"
import script from "./SimpleNewsList.vue?vue&type=script&lang=js&"
export * from "./SimpleNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb969c5",
  null
  
)

export default component.exports